import {
    type GetKnowledgeBaseItemsQuery,
    KbDocumentType,
    type KnowledgeBaseItemPatch,
    KnowledgeBaseItemType,
} from "@generated/client/graphql";

export type KnowledgeBaseListItem =
    GetKnowledgeBaseItemsQuery["knowledgeBaseItems"][number];

export const getLink = (
    orgUname: string | undefined,
    kbItem: KnowledgeBaseListItem,
): string => {
    if (kbItem.type === KnowledgeBaseItemType.Document) {
        const unique_url = kbItem.document?.uniqueUrl;
        switch (kbItem.document?.documentType) {
            case KbDocumentType.Measure:
                return `/o/${orgUname}/admin/measures/${unique_url}`;
            case KbDocumentType.Policy:
                return `/o/${orgUname}/admin/policies/${unique_url}`;
            case KbDocumentType.Custom:
                return `/o/${orgUname}/admin/custom_documents/${unique_url}`;
        }
    }
    if (kbItem.type === KnowledgeBaseItemType.Objective) {
        return `/o/${orgUname}/admin/objectives/${kbItem.externalId}`;
    }
    if (kbItem.type === KnowledgeBaseItemType.Questionnaire) {
        return `/o/${orgUname}/admin/external_questionnaires/${kbItem.externalId}`;
    }
    if (kbItem.type === KnowledgeBaseItemType.Indicator) {
        return `/o/${orgUname}/admin/reporting/overview/${kbItem.entity?.name}`;
    }
    if (kbItem.type === KnowledgeBaseItemType.Framework) {
        return `/o/${orgUname}/admin/frameworks/${kbItem.framework?.cmsId}/${kbItem.externalId}`;
    }
    return `/o/${orgUname}/admin/${kbItem.id}`;
};

export function makeOptimisticKnowledgeBaseUpdate() {
    return function (
        input: {
            ids: string[];
            patch: KnowledgeBaseItemPatch;
        },
        previousQuery?: GetKnowledgeBaseItemsQuery,
    ) {
        if (!previousQuery) return previousQuery;
        const updatedQuery: GetKnowledgeBaseItemsQuery = {
            ...previousQuery,
            knowledgeBaseItems: previousQuery.knowledgeBaseItems.map((item) => {
                if (input.ids.includes(item.id)) {
                    return {
                        ...item,
                        aiVisibilityStatus: input.patch.aiVisibilityStatus,
                    };
                }
                return item;
            }),
        };
        return updatedQuery;
    };
}

export function makeSingleOptimisticKnowledgeBaseUpdate(id: string) {
    return function (
        patch: KnowledgeBaseItemPatch,
        previousQuery?: GetKnowledgeBaseItemsQuery,
    ) {
        if (!previousQuery) return previousQuery;
        const updatedQuery: GetKnowledgeBaseItemsQuery = {
            ...previousQuery,
            knowledgeBaseItems: previousQuery.knowledgeBaseItems.map((item) => {
                if (item.id === id) {
                    return {
                        ...item,
                        aiVisibilityStatus: patch.aiVisibilityStatus,
                    };
                }
                return item;
            }),
        };
        return updatedQuery;
    };
}
